import React from "react";
import INFO from "../../data/user";

import "./styles/socials.css";

const SocialsStacks = () => {

	const logo = INFO.stacks.all

	const logosArray = Array.isArray(logo) ? logo : [logo];

	return (
		<div className="socials" style={{ marginBottom: '25px' }}>

			<div className="project-logos">
				{logosArray.map((logo, index) => (
					<img
						key={index}
						src={logo}
						alt={`Logo ${index}`}
						style={{ width: '35px', height: '35px', marginRight: '10px' }} // Adiciona margem direita de 10px
					/>
				))}

			</div>
		</div>
	);
};

export default SocialsStacks;
